/**
 * GiftCategoryListContainer
 * --
 */
import React from 'react';
import GiftCategoryListPresenter from './GiftCategoryListPresenter';

const GiftCategoryListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <GiftCategoryListPresenter />
    </>
  );
};

export default GiftCategoryListContainer;
